import i18n from '@/utils/lang'
import { message } from 'ant-design-vue'

function isEmptyObject(obj) {
  // 检查参数是否为对象
  if (typeof obj !== 'object' || obj === null) {
    return true
  }

  // 检查对象是否有可枚举的属性
  for (let key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      return false
    }
  }

  return true
}

function copy(text) {
  const textArea = document.createElement('textarea')
  textArea.value = text
  document.body.appendChild(textArea)
  textArea.select()
  document.execCommand('copy')
  document.body.removeChild(textArea)
  message.success(i18n.t('已复制'))
}

function getPermission(keyList = []) {
  let userSession = localStorage.getItem('userSession')
  if (userSession) {
    userSession = JSON.parse(userSession)
  }
  let funcList = userSession.funcList
  keyList.forEach((item, index) => {
    funcList = funcList?.find((elem) => elem.code === item)
    if (index < keyList.length - 1) {
      funcList = funcList?.children || []
    }
  })
  return funcList !== undefined
}

function toFixedUp(value, decimalPlaces) {
  const factor = Math.pow(10, decimalPlaces)
  return (Math.ceil(value * factor) / factor).toFixed(decimalPlaces)
}

/**
 *
 * @param {Array} list 单位列表
 * @param {Object} targetUnit 指定单位
 * @param {Object} baseUnit 被转换单位
 */
const getUnitRate = ({ list, targetUnit, baseUnit }) => {
  if (list && !baseUnit) {
    baseUnit = list.find((item) => item.baseUnit) || {}
  }
  let rate = 1,
    unit = baseUnit.unitName,
    alias = baseUnit.unitNameFull
  if (targetUnit) {
    rate = targetUnit.conversionRate / baseUnit.conversionRate
    unit = targetUnit.unitName
    alias = targetUnit.unitNameFull
  }
  return {
    rate,
    unit,
    alias,
    base_unit: baseUnit.unit,
  }
}

export { isEmptyObject, copy, getPermission, toFixedUp, getUnitRate }
